<div class="wrapper">
  <div class="heading text-type-2">{{ data.activity_id }}</div>
  <div class="activity-ids-details-form">
    <app-activity-id-details
      [data]="data"
    />
  </div>
  <app-project-action-section
    class="actions-section w-[455px]"
  />
</div>
